module.exports = __webpack_public_path__ + "assets/72a2ef0d459d545129b92c386a8347f1.png";